import {HStack} from 'platform/foundation';

import {isNil, isNotNil} from 'ramda';

import {getSafely, isNotNilOrZero} from 'shared/web';

import {Flag} from '../../../../../components/Flag/Flag';
import {StatisticsChartItem} from '../types/StatisticsChartItem';

const LABEL_HEIGHT = 24;
const LABEL_WIDTH = 100;

interface MyAdLabelProps {
  x?: number; // Passed by recharts
  y?: number; // Passed by recharts
  width?: number; // Passed by recharts
  index?: number; // Passed by recharts
  data: StatisticsChartItem[];
  formatter: (value: number) => string;
  comparison: 'positive' | 'negative';
  chartWidth?: number;
}

export function MyAdLabel(props: MyAdLabelProps) {
  if (isNil(props.x) || isNil(props.y) || isNil(props.width) || isNil(props.index)) {
    return null;
  }

  const item = getSafely(props.data, props.index);
  const value = item?.y2;
  const isPositive = (item?.y ?? 0) > (item?.y1 ?? 0);
  const isNegative = !isPositive;
  const label = isNotNilOrZero(value)
    ? `${props.comparison === 'positive' ? '+' : '-'}${props.formatter(value)}`
    : null;

  if (
    !item?.car?.isMyAd ||
    isNil(label) ||
    (props.comparison === 'negative' && !isNegative) ||
    (props.comparison === 'positive' && !isPositive)
  ) {
    return null;
  }

  const defaultX = props.x + props.width + 3;
  const labelRightEdge = defaultX + LABEL_WIDTH;
  const isLabelCutOff = isNotNil(props.chartWidth) && labelRightEdge > props.chartWidth;

  return (
    <foreignObject
      x={
        isLabelCutOff && isNotNil(props.chartWidth) ? props.chartWidth - LABEL_WIDTH - 3 : defaultX
      }
      y={props.y - (props.comparison === 'positive' ? -3 : LABEL_HEIGHT + 3)}
      height={LABEL_HEIGHT}
      width={LABEL_WIDTH}
      pointerEvents="none"
    >
      <HStack justify={isLabelCutOff ? 'flex-end' : 'flex-start'}>
        <Flag label={label} size="small" backgroundColor="general.myAdTag" color="text.primary" />
      </HStack>
    </foreignObject>
  );
}
